module.exports = __webpack_public_path__ + "img/fire-extinguisher-on-check-list.b56e434c.jpg";